import {createReducer} from "../../../_common/common";
import {SET_STATUS_PRESTA} from "../actions/constants";


export const status_presta = createReducer(null, {
    [SET_STATUS_PRESTA]: (state, payload)=> payload
});
